export const csCourses = [
  'Practical Web Design/Dev',
  'Data Structures',
  'Modern Web Programming',
  'Internet Services and Protocols',
  'Algorithms and Analysis',
  'Languages and Computation',
  'Files and Databases',
  'Computer Organization',
];
export const statsCourses = [
  'Data Science',
  'Data Analysis Methods',
  'Linear Optimization',
  'Decision Analytics',
  'Probability',
  'Stochastic Modeling',
  'Mathematical Statistics',
  'Discrete Mathematics',
];
